import { render, staticRenderFns } from "./sms-info.vue?vue&type=template&id=364c390f&scoped=true"
import script from "./sms-info.vue?vue&type=script&lang=js"
export * from "./sms-info.vue?vue&type=script&lang=js"
import style0 from "./sms-info.vue?vue&type=style&index=0&id=364c390f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364c390f",
  null
  
)

export default component.exports